import {
    FETCH_FORMATION_SKILLS_REQUEST,
    FETCH_FORMATION_SKILLS_SUCCESS,
    FETCH_FORMATION_SKILLS_FAIL,
    UPDATE_FORMATION_SKILLS_BULK_REQUEST,
    UPDATE_FORMATION_SKILLS_BULK_SUCCESS,
    UPDATE_FORMATION_SKILLS_BULK_FAIL,
    FETCH_ALL_FORMATION_SKILLS_REQUEST,
    FETCH_ALL_FORMATION_SKILLS_SUCCESS,
    FETCH_ALL_FORMATION_SKILLS_FAIL,
    SET_FORMATION_SKILL_LOADING,
    CLEAR_FORMATION_SKILL_ERROR
} from "../actions/formationSkillActions";

const initialState = {
    list: [],
    allMappings: [],
    loading: false,
    error: null
};

export default function formationSkillReducer(state = initialState, action) {
    switch (action.type) {
        case SET_FORMATION_SKILL_LOADING:
            return { ...state, loading: action.payload };

        case CLEAR_FORMATION_SKILL_ERROR:
            return { ...state, error: null };

        case FETCH_FORMATION_SKILLS_REQUEST:
        case FETCH_ALL_FORMATION_SKILLS_REQUEST:
        case UPDATE_FORMATION_SKILLS_BULK_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_FORMATION_SKILLS_SUCCESS:
            return { ...state, loading: false, list: action.payload || [] };

        case FETCH_ALL_FORMATION_SKILLS_SUCCESS:
            return { ...state, loading: false, allMappings: action.payload || [] };

        case UPDATE_FORMATION_SKILLS_BULK_SUCCESS:
            return { ...state, loading: false };

        case FETCH_FORMATION_SKILLS_FAIL:
        case FETCH_ALL_FORMATION_SKILLS_FAIL:
        case UPDATE_FORMATION_SKILLS_BULK_FAIL:
            return { ...state, loading: false, error: action.error || "Erreur" };

        default:
            return state;
    }
}
